import { useWeb3React } from '@web3-react/core'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'store'
import {
  useAccountTickets,
  useIsActivated,
  useIsLogin,
  useL2AccountId,
} from 'store/account/hooks'
import { useLinkConnected } from 'store/link/hooks'
import { ConnectButtonWrap, ConnectWalletButton } from './ConnectWallet'
import { EnableTradingButton } from './EnableTrading'
import { OpenMyAccountButton } from './OpenMyAccount'
import { updateModal } from '../../store/app/actions/modalActions'
import { useGuideText } from 'store/app/hooks'

export const UserActionGuideButton = memo(() => {
  const dispatch = useAppDispatch()
  const { isActive = false, account = '' } = useWeb3React()
  const isLinkConnected = useLinkConnected()
  const layer2Id = useL2AccountId()
  const isActivated = useIsActivated()
  const isLogin = useIsLogin()
  const tickets = useAccountTickets()
  const { t } = useTranslation()
  const guideText = useGuideText()

  if (!isActive || account === '') {
    return <ConnectWalletButton />
  }
  if (!isLinkConnected) {
    return (
      <ConnectButtonWrap
        onClick={() => {
          dispatch(updateModal({ modal: 'verify', open: true }))
        }}
      >
        {guideText ? guideText : ' Connect ZKEX'}
      </ConnectButtonWrap>
    )
  }
  if (!isLogin && !tickets) {
    return <EnableTradingButton />
  }

  if (!layer2Id) {
    return <OpenMyAccountButton />
  }
  if (!isActivated) {
    return (
      <OpenMyAccountButton>
        {/* {guideText} */}
        {!guideText
          ? t('open-my-account-active-my-account', {
              defaultValue: 'Activate My Account',
            })
          : guideText}
        {/* {t('open-my-account-active-my-account', {
          defaultValue: 'Activate My Account',
        })} */}
      </OpenMyAccountButton>
    )
  }

  return null
})
